import { AxiosInstance } from "axios"
import { ServiceResponse } from "../../../../core/api/apiTypes"
import { DeliveryLocation, DeliveryLocationDetails } from "./deliveryLocationsTypes"

export enum DeliveryLocationsQuery {
    LIST = "delivery-locations-for-merchant",
    DETAILS = "delivery-location-details-for-merchant",
}

type DeliveryLocationsParam = Readonly<{
    merchantId: number
}>

export type DeliveryLocationsResponse = Readonly<{
    deliveryLocations: DeliveryLocation[]
}>

export async function fetchDeliveryLocations(
    { merchantId }: DeliveryLocationsParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<DeliveryLocationsResponse> {
    const url = `/merchants/${merchantId}/products/delivery/locations`

    const { data } = await axios.get(url, {
        signal,
    })

    return data
}

type DeliveryLocationParams = Readonly<{
    deliveryLocationId: number
}>

export async function deleteDeliveryLocation(
    { deliveryLocationId }: DeliveryLocationParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.delete(`/delivery/locations/${deliveryLocationId}`, {
        signal,
    })
    return data
}

type DeliveryLocationDetailsParam = Readonly<{
    deliveryLocationId: string
}>

export type DeliveryLocationDetailsResponse = Readonly<{
    deliveryLocation: DeliveryLocationDetails
}>

export async function deliveryLocationDetails(
    { deliveryLocationId }: DeliveryLocationDetailsParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<DeliveryLocationDetailsResponse> {
    const url = `/delivery/locations/${deliveryLocationId}`

    const { data } = await axios.get(url, {
        signal,
    })

    return data
}

export async function createDeliveryLocation(
    deliveryLocation: DeliveryLocationDetails,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.post(
        `/delivery/locations`,
        {
            deliveryLocation,
        },
        {
            signal,
        },
    )
    return data
}

type UpdateDeliveryLocationParam = Readonly<{
    deliveryLocation: DeliveryLocationDetails
    deliveryLocationId: string
}>

export async function updateDeliveryLocation(
    { deliveryLocation, deliveryLocationId }: UpdateDeliveryLocationParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.post(
        `/delivery/locations/${deliveryLocationId}`,
        {
            deliveryLocation,
        },
        {
            signal,
        },
    )
    return data
}
